module.exports = __webpack_public_path__ + "static/media/01.8dac9c3e.jpg";